import {
  LayoutModule,
  ModuleProperties,
  scrollTo,
  useAnimationStates,
  useRenderedChildren,
  useShowInstructions,
} from '@backstage-components/base';
import {Box, type BoxProps} from '@chakra-ui/react';
import {css, cx} from '@emotion/css';
import {motion} from 'framer-motion';
import {useSubscription} from 'observable-hooks';
import {FC, Fragment} from 'react';
import {
  ComponentDefinition,
  SchemaType,
  reactName,
} from './ContainerLayoutDefinition';

export interface IContainerProps extends ModuleProperties, SchemaType {}

export type ContainerLayoutDefinition = LayoutModule<
  typeof reactName,
  SchemaType
>;

export const TEST_ID = `${reactName}-test`;

const MotionBox = motion<BoxProps>(Box);

export const ContainerLayout: FC<ContainerLayoutDefinition> = (definition) => {
  const {slotRenderer: Component = () => <Fragment />} = definition;
  const {props} = definition;
  const {animationStates} = props;
  const renderedChildren = useRenderedChildren(Component, definition.slots);

  const {observable, broadcast} = useShowInstructions(
    ComponentDefinition.instructions,
    definition
  );
  const motionOptions = useAnimationStates(
    observable,
    broadcast,
    animationStates
  );

  useSubscription(observable, (inst) => {
    if (inst.type === 'Container:scrollTo') {
      const {elementId, anchorElId, scrollX, scrollY} = inst.meta;
      scrollTo({elementId, anchorElId, scrollX, scrollY});
    }
  });

  const styleClassName = css`
    ${definition.style}
    ${definition.props.styleAttr}
  `;
  return (
    <MotionBox
      id={definition.id}
      data-testid={TEST_ID}
      className={cx(styleClassName, definition.mid)}
      {...motionOptions}
    >
      {renderedChildren}
    </MotionBox>
  );
};
